import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { closeAuction, openAuction } from '../../../../redux/reducers';
import { selectIsAuctionEnabled, selectIsAuctionOpen, selectIsAutobrokerEnabled } from '../../../../selectors/auction';
import { selectActiveServiceId } from '../../../../selectors/publishTerms';
import { trackAuctionOpen } from '../../../../tracking';
import { AuctionDesktop } from './AuctionDesktop';

export let isAuctionOpenedFirstTime = true;

export const AuctionDesktopContainer = () => {
  const isMobile = useIsMobileDevice();

  const isAuctionOpen = useSelector(selectIsAuctionOpen);
  const isAuctionEnabled = useSelector(selectIsAuctionEnabled);
  const isAutobrokerEnabled = useSelector(selectIsAutobrokerEnabled);
  const selectedServiceId = useSelector(selectActiveServiceId);

  const dispatch = useDispatch<TDispatch>();

  const handleClick = React.useCallback(() => {
    if (isAuctionOpen) {
      dispatch(closeAuction());
    } else {
      dispatch(openAuction());

      if (isAuctionOpenedFirstTime) {
        trackAuctionOpen(isAutobrokerEnabled);

        isAuctionOpenedFirstTime = false;
      }
    }
  }, [isAuctionOpen, isAutobrokerEnabled, isAuctionOpenedFirstTime, dispatch]);

  if (isMobile || !selectedServiceId || !isAuctionEnabled) {
    return null;
  }

  return (
    <AuctionDesktop
      isOpen={isAuctionOpen}
      isAutobrokerEnabled={isAutobrokerEnabled}
      serviceId={selectedServiceId}
      onClick={handleClick}
    />
  );
};
